import { Directus } from '@directus/sdk';
import { API_PROJECT_LINK_MENU_FIELDS } from '../common/collections/model/menus/APIMenus';
import { API_PROJECT_LINK_MENU_TRANSLATIONS_FIELDS } from '../common/collections/model/menus/APIMenusTranslation';
import { API_PROJECT_PARTNERS_ID_FIELDS } from '../common/collections/model/partners/APIPartners';
import { API_PROJECTS_PARTNERS_ID_TRANSLATIONS_FIELDS } from '../common/collections/model/partners/APIPartnersTranslations';
import { API_DATA_SECTION_FIELDS } from '../common/collections/model/projects/APIDataSection';
import { API_DATA_SECTION_FIELDS_TRANSLATIONS_FIELDS } from '../common/collections/model/projects/APIDataSectionTranslations';
import { API_FORMATION_SECTION_FIELDS } from '../common/collections/model/projects/APIFormationSection';
import { API_FORMATION_SECTION_FIELDS_TRANSLATIONS_FIELDS } from '../common/collections/model/projects/APIFormationSectionTranslations';
import { API_PROJECTS_DESCRIPTION_METRICS_FIELDS } from '../common/collections/model/projects/APIProjectDescriptionMetrics';
import { API_PROJECTS_DESCRIPTION_METRICS_ID_FIELDS } from '../common/collections/model/projects/APIProjectDescriptionMetricsId';
import { API_PROJECT_DESCRIPTION_METRICS_ID_TRANSLATIONS_FIELDS } from '../common/collections/model/projects/APIProjectDescriptionMetricsIdTranslations';
import { API_PROJECTS_FINANCIAL_INCLUSION_SECTION_FIELDS } from '../common/collections/model/projects/APIProjectFinancialInclusionSection';
import { API_PROJECTS_FINANCIAL_INCLUSION_SECTION_TRANSLATIONS_FIELDS } from '../common/collections/model/projects/APIProjectFinancialInclusionSectionTranslations';
import { API_PROJECTS_FIRST_TYPE_FIELDS } from '../common/collections/model/projects/APIProjectFirstType';
import { API_PROJECTS_LAST_SECTION_FIELDS } from '../common/collections/model/projects/APIProjectLastSectionFirstType';
import { API_PROJECTS_LAST_SECTION_TRANSLATIONS_FIELDS } from '../common/collections/model/projects/APIProjectLastSectionFirstTypeTranslations';
import { API_PROJECT_PARTNERS_FIELDS } from '../common/collections/model/projects/APIProjectPartners';
import { API_PROJECT_PUBLICATIONS_RELATION_FIELDS } from '../common/collections/model/projects/APIProjectPublications';
import { API_PROJECTS_PUBLICATIONS_ID_FIELDS } from '../common/collections/model/projects/APIProjectPublicationsId';
import { API_PROJECT_PUBLICATIONS_ID_TRANSLATIONS_FIELDS } from '../common/collections/model/projects/APIProjectPublicationsIdTranslations';
import { API_PROJECTS_PUBLICATIONS_SECTION_FIELDS } from '../common/collections/model/projects/APIProjectPublicationsSection';
import { API_PROJECTS_PUBLICATIONS_TRANSLATIONS_FIELDS } from '../common/collections/model/projects/APIProjectPublicationsSectionTranslations';
import { API_PROJECTS_RESULTS_SECTION_FIELDS } from '../common/collections/model/projects/APIProjectResultsSection';
import { API_PROJECTS_RESULTS_SECTION_TRANSLATIONS_FIELDS } from '../common/collections/model/projects/APIProjectResultsSectionTranslations';
import { API_PROJECTS_FIELDS } from '../common/collections/model/projects/APIProjects';
import { API_PROJECTS_NUMBERS_DESC_COMPONENT_FIELDS } from '../common/collections/model/projects/APIProjectsNumberDescComponent';
import { API_DATA_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_FIELDS, API_FORMATION_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_FIELDS, API_LAST_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_FIELDS } from '../common/collections/model/projects/APIProjectsNumberDescComponentId';
import { API_DATA_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_TRANSLATIONS_FIELDS, API_FORMATION_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_TRANSLATIONS_FIELDS, API_LAST_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_TRANSLATIONS_FIELDS } from '../common/collections/model/projects/APIProjectsNumberDescComponentIdTranslations';
import { API_PROJECTS_TRANSLATIONS_FIELDS } from '../common/collections/model/projects/APIProjectsTranslations';
import { default as APIListProjectsResponse } from './response/APIListProjectsResponse';
export default class DirectusCmsProjectsApi {
    static getInstance(basePath) {
        if (!DirectusCmsProjectsApi.instance) {
            if (!basePath) {
                basePath = process.env.CMS_URL;
            }
            DirectusCmsProjectsApi.instance = new DirectusCmsProjectsApi();
            DirectusCmsProjectsApi.instance.api = new Directus(basePath);
        }
        return DirectusCmsProjectsApi.instance;
    }
    async listProjects(lang, requestOptions) {
        var _a;
        const response = await ((_a = this.api) === null || _a === void 0 ? void 0 : _a.items('project').readByQuery(Object.assign(Object.assign({}, requestOptions), { meta: '*', sort: ['id'], fields: [
                ...API_PROJECTS_FIELDS,
                ...API_PROJECT_LINK_MENU_FIELDS,
                ...API_PROJECT_LINK_MENU_TRANSLATIONS_FIELDS,
                ...API_PROJECTS_TRANSLATIONS_FIELDS,
                ...API_PROJECT_PARTNERS_FIELDS,
                ...API_PROJECT_PARTNERS_ID_FIELDS,
                ...API_PROJECTS_PARTNERS_ID_TRANSLATIONS_FIELDS,
                ...API_PROJECTS_FIRST_TYPE_FIELDS,
                ...API_DATA_SECTION_FIELDS,
                ...API_DATA_SECTION_FIELDS_TRANSLATIONS_FIELDS,
                ...API_FORMATION_SECTION_FIELDS,
                ...API_FORMATION_SECTION_FIELDS_TRANSLATIONS_FIELDS,
                ...API_DATA_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_FIELDS,
                ...API_FORMATION_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_FIELDS,
                ...API_DATA_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_TRANSLATIONS_FIELDS,
                ...API_FORMATION_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_TRANSLATIONS_FIELDS,
                ...API_PROJECTS_NUMBERS_DESC_COMPONENT_FIELDS,
                ...API_PROJECTS_RESULTS_SECTION_FIELDS,
                ...API_PROJECTS_RESULTS_SECTION_TRANSLATIONS_FIELDS,
                ...API_PROJECTS_LAST_SECTION_FIELDS,
                ...API_PROJECTS_LAST_SECTION_TRANSLATIONS_FIELDS,
                ...API_LAST_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_FIELDS,
                ...API_LAST_SECTION_PROJECTS_NUMBER_DESC_COMPONENT_TRANSLATIONS_FIELDS,
                ...API_PROJECTS_DESCRIPTION_METRICS_FIELDS,
                ...API_PROJECTS_DESCRIPTION_METRICS_ID_FIELDS,
                ...API_PROJECT_DESCRIPTION_METRICS_ID_TRANSLATIONS_FIELDS,
                ...API_PROJECTS_PUBLICATIONS_SECTION_FIELDS,
                ...API_PROJECT_PUBLICATIONS_RELATION_FIELDS,
                ...API_PROJECTS_PUBLICATIONS_ID_FIELDS,
                ...API_PROJECT_PUBLICATIONS_ID_TRANSLATIONS_FIELDS,
                ...API_PROJECTS_PUBLICATIONS_TRANSLATIONS_FIELDS,
                ...API_PROJECTS_FINANCIAL_INCLUSION_SECTION_FIELDS,
                ...API_PROJECTS_FINANCIAL_INCLUSION_SECTION_TRANSLATIONS_FIELDS
            ], filter: Object.assign(Object.assign({}, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.filter), { status: 'published' }), deep: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                translations: { _filter: { languages_code: { lang: { _eq: lang } } } },
                partners: {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    partner_id: {
                        translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                    }
                },
                project_first_type: {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    data_section: {
                        translations: { _filter: { languages_code: { lang: { _eq: lang } } } },
                        projects_number_desc_component: {
                            projects_number_desc_component_id: {
                                translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                            }
                        }
                    },
                    formation_section: {
                        translations: { _filter: { languages_code: { lang: { _eq: lang } } } },
                        projects_number_desc_component: {
                            projects_number_desc_component_id: {
                                translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                            }
                        }
                    },
                    results_impacts_section: {
                        translations: { _filter: { languages_code: { lang: { _eq: lang } } } },
                        metrics: {
                            project_description_metrics_id: {
                                translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                            }
                        }
                    },
                    last_section_first_type: {
                        translations: { _filter: { languages_code: { lang: { _eq: lang } } } },
                        projects_number_desc_component: {
                            projects_number_desc_component_id: {
                                translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                            }
                        }
                    },
                    publications_section: {
                        translations: { _filter: { languages_code: { lang: { _eq: lang } } } },
                        publications: {
                            project_publications_id: {
                                translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                            }
                        }
                    },
                    financial_inclusion_section: {
                        translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                    }
                }
            } })));
        return new APIListProjectsResponse(response);
    }
}
